module.exports = __webpack_public_path__ + "static/media/owlsome-tech.68d97bd9.jpg";